import { googleLogout } from "@react-oauth/google"

export function isAuthenticated() {
  const userId = localStorage.getItem("userId");
  const jwtToken = localStorage.getItem('jwtToken');

  return userId && jwtToken;
}

let isLoggingOut = false

export function logout() {
  if (isLoggingOut) return
  isLoggingOut = true

  clearCredentials()

  if (window.location.pathname !== '/login') {
    window.location.assign('/login')
  }
}

export function clearCredentials() {
  googleLogout();
  localStorage.removeItem("user");
  localStorage.removeItem("userId");
  localStorage.removeItem("socket");
  localStorage.removeItem("jwtToken");
}
